import React from 'react';
import { useTranslation } from 'react-i18next';

import {TagInfo, copyTagDescriptor } from '@/features/tags/tagsSlice';

import Button from '@/components/Common/Button';
import FlexRow from '@/components/Common/FlexRow';
import Input from '@/components/Common/Input';
import { TextArea } from '@/components/Common/Input';

import { CatHeader } from '@/pages/Projects/Project';
export interface TagProps {
	index:				number;
	tag:				TagInfo | null;
	setTag:				(tag: TagInfo) => any;
	onClose:			() => any;
}

const Tag = (props: TagProps) => {
  const { t } = useTranslation();

  const isNew = props.index == -2;

  const [tag, setTag] = React.useState(null as TagInfo | null);
  const [changes, setChanges] = React.useState(false);
  const [triedSave, setTriedSave] = React.useState(false);

  React.useEffect(() => {
    setTag(props.tag);
  }, [props.tag]);

  const nameInvalid = React.useMemo(() => {
    return !tag || tag.tag.trim() =='';
  }, [tag]);

  const descriptionInvalid = React.useMemo(() => {
    return !tag || tag.desc.trim() =='';
  }, [tag]);

  const updateName = React.useCallback((val: string) => {
    if (!tag)
      return;

    let ntag = copyTagDescriptor(tag);
    ntag.tag = val;

    setTag(ntag);
    setChanges(true);
  }, [tag, setTag]);

  const updateDescription = React.useCallback((val: string) => {
    if (!tag)
      return;

    let ntag = copyTagDescriptor(tag);
    ntag.desc = val;

    setTag(ntag);
    setChanges(true);
  }, [tag, setTag]);

  const handleSave = React.useCallback(() => {
    if (!tag || nameInvalid || descriptionInvalid) {
      setTriedSave(true);
      return;
    }

    setTriedSave(false);
    props.setTag(tag);
    setChanges(false);
    props.onClose();
  }, [tag, props.setTag, nameInvalid, descriptionInvalid]);

  if (!tag)
    return;

  return (
  <React.Fragment>
    <FlexRow direction="column"
             align="start"
             className="px-[32px]">
      <FlexRow direction="column"
		       align="start"
		       className="py-0 gap-[16px] max-w-[620px]">
	    <CatHeader caption={isNew ? 'tags:new_tag:caption' : 'tags:tag:edit_tag'} />

		<Input label={t('tags:tag_name') + '*'}
		       isInvalid={triedSave && nameInvalid}
		       errorMessage={t('tags:tag:name:invalid')}
		       value={tag ? tag.tag : ''}
		       onValueChange={updateName} />
		<TextArea label={t('tags:description') + '*'}
		       isInvalid={triedSave && descriptionInvalid}
		       errorMessage={t('tags:tag:description:invalid')}
		       value={tag ? tag.desc : ''}
		       onValueChange={updateDescription}
		       minRows={4}
		       maxRows={8} />
	  </FlexRow>
    </FlexRow>
    <FlexRow className="absolute bottom-0 p-[32px] bg-white z-10 justify-end gap-[16px]">
      <Button className="uppercase"
              caption={t('tags:cancel')}
              onClick={() => props.onClose()}
              layout="white" />
      <Button caption={t('tags:save')}
              icon="save"
              isDisabled={!changes || (triedSave && (nameInvalid || descriptionInvalid))}
              onClick={() => handleSave()} />
    </FlexRow>
  </React.Fragment>
  );
};

export default Tag